import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface WhoAmIResponse extends BackendResponse, Profile {}

export interface WhoAmIParameters extends NextApiParams {
  includeUnitIds: boolean | null;
}

export const whoAmi = withNextApi<WhoAmIResponse, WhoAmIParameters>(
  "/auth/WhoAmI",
  {
    method: "GET",
  }
);

export interface Profile {
  name: string;
  provider: string;
  id: string;
  claims: ProfileClaim[];
  hasCvpToken: boolean;
  hasVismaToken: boolean;
}

export interface ProfileClaim {
  name: string;
  value: string;
}
